/* eslint-disable */
var boards = require('./boards');
var Connection = require('./connection-browser');
var protocols = require('./protocols');
var AvrgirlArduino = require('./avrgirl-arduino');

module.exports = AvrgirlArduino(boards, Connection, protocols);

